import { 
  LATCHING_TIME_API_LOADING,
  SAVE_LATCHING_TIME_GRAPH
 } from "../../constants/graphConstants/connectedClientsGraphConstants";

 export const routerLatchingTimeReducer = (state = { latchTime: [] },action) => {
    switch (action.type) {
        case LATCHING_TIME_API_LOADING:
          return {
            ...state,
            latchTime: [],
            loading: action.payload,
          };
        case SAVE_LATCHING_TIME_GRAPH:
          return {
            ...state,
            loading: false,
            latchTime: action.payload,
          };
        default:
          return state;
      }
 }